import AiReport from './aiReport';
import { connect } from 'react-redux';

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedAiReport = connect(
  null,
  mapDispatchToProps
)(AiReport);

export default ConnectedAiReport;
